import { render } from "./UserNavbar.vue?vue&type=template&id=281a875c&scoped=true"
import script from "./UserNavbar.vue?vue&type=script&lang=js"
export * from "./UserNavbar.vue?vue&type=script&lang=js"

import "./UserNavbar.vue?vue&type=style&index=0&id=281a875c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281a875c"]])

export default __exports__